import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.83999 7.82698V24.1736C8.82959 24.4204 8.88792 24.6651 9.00846 24.8807C9.12901 25.0962 9.30704 25.274 9.52271 25.3943C9.73839 25.5146 9.98323 25.5726 10.2299 25.5619C10.4767 25.5512 10.7155 25.4722 10.92 25.3336L23.1867 17.1603C23.3682 17.0383 23.5169 16.8736 23.6197 16.6806C23.7225 16.4876 23.7763 16.2723 23.7763 16.0536C23.7763 15.835 23.7225 15.6197 23.6197 15.4267C23.5169 15.2337 23.3682 15.0689 23.1867 14.947L10.92 6.66698C10.7155 6.52847 10.4767 6.44946 10.2299 6.43875C9.98323 6.42805 9.73839 6.48607 9.52271 6.60635C9.30704 6.72663 9.12901 6.90444 9.00846 7.11996C8.88792 7.33548 8.82959 7.58025 8.83999 7.82698Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }